<app-modal
  [isVisible]="isVisible()"
  [config]="modalConfig()"
  (confirmed)="onConfirm()"
  (secondary)="onBack()"
  (cancelled)="onCancel()"
  (closed)="onCancel()"
>
  <!-- Step indicator — same `<app-step-indicator>` chrome every wizard
       modal in the app uses (org-selector, create-control, create-task,
       create-vendor, processing-activity, vendor-request). One visual
       grammar for progress across every creation/edit flow. -->
  <app-step-indicator
    [steps]="stepConfigs()"
    [currentStep]="_subStep()"
    [maxReachedStep]="maxReachedStep()"
    [clickable]="true"
    (stepClicked)="onStepClicked($event)"
  ></app-step-indicator>

  <div class="step-body">
    @if (_subStep() === 'category') {
      <p class="step-hint">{{ 'content_type_modal.description' | transloco }}</p>
      <div class="dtp-list">
        @for (cat of _documentTypes(); track cat.id) {
          <button
            type="button"
            class="dtp-row"
            (click)="onCategorySelect(cat)"
            [attr.aria-label]="cat | localizedName: locale()"
          >
            @let catKind = getCategoryKindFromCode(cat.code);
            @if (catKind) {
              <app-category-icon [category]="catKind" />
            }
            <div class="dtp-info">
              <div class="dtp-name">{{ cat | localizedName: locale() }}</div>
            </div>
            <mat-icon class="dtp-chevron" aria-hidden="true">chevron_right</mat-icon>
          </button>
        }
        @if (_documentTypes().length === 0) {
          <p class="dtp-loading">{{ 'common.loading' | transloco }}</p>
        }
      </div>
    } @else {
      <div class="dtp-list">
        @for (sub of _filteredSubtypes(); track sub.id) {
          <button
            type="button"
            class="dtp-row"
            [class.selected]="_selectedSubtype()?.id === sub.id"
            [attr.aria-pressed]="_selectedSubtype()?.id === sub.id"
            (click)="onSubtypeSelect(sub)"
          >
            <app-kind-icon [kind]="getDocKindFromSubtypeCode(sub.code)" />
            <div class="dtp-info">
              <div class="dtp-name">{{ sub | localizedName: locale() }}</div>
              @if (sub | localizedDescription: locale(); as description) {
                <div class="dtp-description">{{ description }}</div>
              }
            </div>
            @if (_selectedSubtype()?.id === sub.id) {
              <mat-icon class="dtp-check" aria-hidden="true">check</mat-icon>
            }
          </button>
        }
      </div>

      @if (_isCustomSubtype()) {
        <div class="dtp-custom-input">
          <label class="dtp-custom-label" for="custom-type-name">
            {{ 'content_type_modal.custom_name_label' | transloco }}
          </label>
          <input
            id="custom-type-name"
            type="text"
            class="dtp-custom-field"
            [placeholder]="'content_type_modal.custom_name_placeholder' | transloco"
            [value]="_customTypeName()"
            (input)="_customTypeName.set($any($event.target).value)"
          />
        </div>
      }
    }
  </div>
</app-modal>
